import React, { Component } from 'react';
import {
    Col, Row, CardDeck, Card, CardImg, CardTitle, CardText, Button
} from 'reactstrap';

class NYB extends Component {
    render() {
        return (
            <div>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: '1em' }}>
                    <img src='./img/nyb-logo.png' alt='nyb logo' width='400px' height='100px' />
                </div>
                <Film />
                <RYB />
                <UL />
                <PinP />
                <Service />
                <Marketing />
            </div>
        )
    }
}

class Film extends Component {
    render() {
        return (
            <div>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: '3em' }}>
                    <h1> - NYB Film Competition - </h1>
                </div>
                <Col>
                <div style={{padding:'2em'}}>
                <p style={{textAlign:'center'}}> The National Youth Board challenges USPC to show us what makes YOU #ponycluproud in 1 minute or less in the 
                    2020 USPC Film Competition. Show us why you love Pony Club, teach something relevant to your next certification, 
                    or make a fun barn skit! Be creative with content and aim to inspire Pony Club members from around the nation!
                </p>
                <p style={{textAlign:'center'}}>
                        Video
                     submissions are due to NYBchair@ponyclub.org by December 31, 2020. Footage must meet Pony Club horse management and 
                     safety expectations at all times. Awards will be presented at the 2021 Symposium and Convention in St. Louis, 
                     Missouri. Let's get filming! 
                </p>
                </div>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: '3em' }}>
                <img src='./img/film2.png' alt='Film Competition Logo' height='600px'></img>
                </div>
                </Col>
            </div>
        )
    }
}

class RYB extends Component {
    render() {
        return (
            <div>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: '3em' }}>
                    <h1> - Regional Youth Boards - </h1>
                </div>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: '3em' }}>
                    <p> Information to come! </p>
                </div>
            </div>
        )
    }
}

class UL extends Component {
    render() {
        return (
            <div>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: '3em' }}>
                    <h1> - Upper Level Opportunities - </h1>
                </div>
                <CardDeck style={{paddingTop:'2em'}}>
                    <Card>
                        <CardImg src='./img/research.png' alt='research' />
                        <CardTitle style={{ fontSize: '20px', fontWeight: 'bold', textAlign: 'center' }} > Research Fair at Symposium </CardTitle>
                        <CardText style={{ textAlign: 'center' }}> Put your research skills to the test with the USPC Research Fair hosted by the Grayson-Jockey Club Research Foundation!  </CardText>
                        <Button color='primary' href='https://www.ponyclub.org/ContentDocs/AnnualMeeting/2020%20RPF%20entry.pdf'> Learn More </Button>
                    </Card>
                    <Card>
                        <CardImg src='./img/inter.png' alt='research' />
                        <CardTitle style={{ fontSize: '20px', fontWeight: 'bold', textAlign: 'center' }} > International Exchange </CardTitle>
                        <CardText style={{ textAlign: 'center' }}> Ever wanted to compete internationally? Now is your chance to represent team USA and USPC! </CardText>
                        <Button color='primary' href='https://www.ponyclub.org/Members/InternationalExchanges/Default.aspx'> Learn More </Button>
                    </Card>
                    <Card>
                        <CardImg src='./img/nyc.png' alt='research' />
                        <CardTitle style={{ fontSize: '20px', fontWeight: 'bold', textAlign: 'center' }} > National Youth Congress </CardTitle>
                        <CardText style={{ textAlign: 'center' }}> Learn valuable leaderhsip skills while having fun with like minded Pony Club members from around the nation! </CardText>
                        <Button color='primary' href='https://www.ponyclub.org/Members/Leadership/NatYouthCongress/Default.aspx'> Learn More </Button>
                    </Card>
                    <Card>
                        <CardImg src='./img/leaders.png' alt='research' />
                        <CardTitle style={{ fontSize: '20px', fontWeight: 'bold', textAlign: 'center' }} > National Youth Board </CardTitle>
                        <CardText style={{ textAlign: 'center' }}> Have fun and make a difference in Pony Club with Pony Club members from around the nation!  </CardText>
                        <Button color='primary' href='https://www.ponyclub.org/Members/Leadership/NatYouthBoard/Default.aspx'> Learn More </Button>
                    </Card>
                </CardDeck>
                <CardDeck style={{ marginTop: '1em' }}>
                    <Card>
                        <CardImg src='./img/vi.png' alt='research' />
                        <CardTitle style={{ fontSize: '20px', fontWeight: 'bold', textAlign: 'center' }} > Visiting Instructor Program </CardTitle>
                        <CardText style={{ textAlign: 'center' }}> Share your knowledge with Pony Clubs across the nation through the visiting instructor program! </CardText>
                        <Button color='primary' href='https://www.ponyclub.org/Members/Leadership/Visiting/Default.aspx'> Learn More </Button>
                    </Card>
                    <Card>
                        <CardImg src='./img/champs.png' alt='research' />
                        <CardTitle style={{ fontSize: '20px', fontWeight: 'bold', textAlign: 'center' }} > College Scholarships </CardTitle>
                        <CardText style={{ textAlign: 'center' }}> Headed off to College? Take advantage of USPC college scholarships to help finance those textbooks! </CardText>
                        <Button color='primary' href='https://www.ponyclub.org/Members/CollegeScholarships/Default.aspx'> Learn More </Button>
                    </Card>
                    <Card>
                        <CardImg src='./img/teach.png' alt='research' />
                        <CardTitle style={{ fontSize: '20px', fontWeight: 'bold', textAlign: 'center' }} > Examiner, Volunteer, Teacher </CardTitle>
                        <CardText style={{ textAlign: 'center' }}> Ready to examine younger members, teach the next generation of horsemen, or learn what it is like on the logistics side of rallies? </CardText>
                        <Button color='primary' href='https://www.ponyclub.org/Certifications/Default.aspx'> Learn More </Button>
                    </Card>
                    <Card>
                        <CardImg src='./img/college.png' alt='research' />
                        <CardTitle style={{ fontSize: '20px', fontWeight: 'bold', textAlign: 'center' }} > Championships </CardTitle>
                        <CardText style={{ textAlign: 'center' }}> Represnt your club, region, and team at the national level while serving as a role model for younger members! </CardText>
                        <Button color='primary' href='https://www.ponyclub.org/Events/Championships/'> Learn More </Button>
                    </Card>
                </CardDeck>
            </div>
        )
    }
}

class PinP extends Component {
    render() {
        return (
            <div>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: '3em' }}>
                    <h1> - Pin Promise - </h1>
                </div>

                <Row style={{display:'flex', justifyContent: "center", alignItems: "center"}}>

                    <img src='./img/pin1.png' alt='pin photo1' width='250px' height='175px' />
                    <img src='./img/pin5.png' alt='pin photo2' width='250px' height='175px' />
                    <img src='./img/pin2.png' alt='pin photo3' width='250px' height='175px' />
                    <img src='./img/pin3.png' alt='pin photo4' width='250px' height='175px' />
                    <img src='./img/pin4.png' alt='pin photo5' width='250px' height='175px' />
                    <img src='./img/pin6.png' alt='pin photo6' width='250px' height='175px' />

                </Row>

                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <h3> Where do you wear your Pony Club pin? </h3>
                </div>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <p> Come find the NYB at LRK3DE and support USPC by wearing your Pony Club pin! </p>
                </div>

            </div>
        )
    }
}

class Service extends Component {
    render() {
        return (
            <div>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: '3em' }}>
                    <h1> - Service - </h1>
                </div>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <img src='./img/ser.png' alt='service' width='400px' style={{ borderRadius: '5px' }} />
                </div>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: '1em' }}>
                    <p> Every year, the National Youth Board completes an annual service project during the USPC symposium and convention!</p>
                </div>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <p> In 2020, we volunteered at <a href='https://www.littlebit.org/'> Little Bits Therapeutic Riding Center </a></p>
                </div>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <p> Please join our month of service in August and share a service project you, your club, or friends did with the NYB for a chance to be featured on our Facebook page! </p>
                </div>

            </div>
        )
    }
}

class Marketing extends Component {
    render() {
        return (
            <div>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: '3em' }}>
                    <h1> - Marketing - </h1>
                </div>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <p> Our marketing team is hard at work to get information out to USPC members. Always be on the look out for exciting opportunities and news shared by our borad on our Facebook page!  </p>
                </div>
                <h3 style={{ paddingTop: '2em', textAlign: 'center' }}> Follow the NYB on Facebook </h3>
                <a href='https://www.facebook.com/nationalyouthboard/' style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <img src='./img/facebook.png' alt='USPC NYB Facebook' height='100px' />
                </a>
            </div>
        )
    }
}

export default NYB;
